import { useEffect, useRef } from 'react';

function generateSessionId(): string {
  return `${Date.now()}-${Math.random().toString(36).substring(2, 15)}`;
}

function getSessionId(): string {
  const existing = sessionStorage.getItem('utm_session_id');
  if (existing) return existing;
  
  const newId = generateSessionId();
  sessionStorage.setItem('utm_session_id', newId);
  return newId;
}

export function useUtmTracker() {
  const trackedRef = useRef(false);

  useEffect(() => {
    if (trackedRef.current) return;
    
    const urlParams = new URLSearchParams(window.location.search);
    
    const utmSource = urlParams.get('utm_source');
    const utmMedium = urlParams.get('utm_medium');
    const utmCampaign = urlParams.get('utm_campaign');
    const utmTerm = urlParams.get('utm_term');
    const utmContent = urlParams.get('utm_content');
    const gclid = urlParams.get('gclid');

    if (!utmSource && !utmMedium && !utmCampaign && !gclid) {
      return;
    }

    trackedRef.current = true;

    const sessionId = getSessionId();
    const visitData = {
      utmSource,
      utmMedium,
      utmCampaign,
      utmTerm,
      utmContent,
      gclid,
      landingPage: window.location.pathname,
      referrer: document.referrer || null,
      sessionId
    };

    fetch('/api/utm/track', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(visitData)
    })
      .then(res => res.json())
      .then(data => {
        if (data.tracked && data.visitId) {
          sessionStorage.setItem('utm_visit_id', data.visitId);
        }
      })
      .catch(err => {
        console.error('UTM tracking failed:', err);
      });
  }, []);
}

export function getUtmVisitId(): string | null {
  return sessionStorage.getItem('utm_visit_id');
}

export async function markConversion(conversionType: string, conversionValue?: number): Promise<boolean> {
  const visitId = getUtmVisitId();
  if (!visitId) return false;

  try {
    const res = await fetch(`/api/utm/convert/${visitId}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ conversionType, conversionValue })
    });
    return res.ok;
  } catch {
    return false;
  }
}
